import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { cardClose, cardToggle } from './card-animation';
import { PlateNumber } from '../input-plate/types';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css'],
  animations: [cardToggle, cardClose],
  encapsulation: ViewEncapsulation.None,
})
export class CardComponent implements OnInit {
  @Input() headerContent: string;
  @Input() title: string;
  @Input() blockClass: string;
  @Input() cardClass: string;
  @Input() cardBodyClass: string;
  @Input() classHeader = false;
  @Input() printAction = false;
  @Input() ExportAction = false;
  @Output() onPrint: EventEmitter<any> = new EventEmitter<any>();
  @Output() onExport: EventEmitter<any> = new EventEmitter<any>();

  cardToggle = 'expanded';
  cardClose = 'open';
  fullCard: string;
  fullCardIcon: string;
  loadCard = false;
  isCardToggled = false;
  cardLoad: string;

  constructor() {}

  ngOnInit() {}

  toggleCard(event) {
    this.cardToggle = this.cardToggle === 'collapsed' ? 'expanded' : 'collapsed';
  }

  closeCard(event) {
    this.cardClose = this.cardClose === 'closed' ? 'open' : 'closed';
  }

  fullScreen(event) {
    this.fullCard = this.fullCard === 'full-card' ? '' : 'full-card';
    this.fullCardIcon = this.fullCardIcon === 'icofont-resize' ? '' : 'icofont-resize';
  }

  cardRefresh(event) {
    this.loadCard = true;
    this.cardLoad = 'card-load';
    setTimeout(() => {
      this.cardLoad = '';
      this.loadCard = false;
    }, 3000);
  }

  emitPrintAction($event: MouseEvent) {
    this.onPrint.emit();
  }

  emitExportAction($event: MouseEvent) {
    this.onExport.emit();
  }
}
